let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lEAPB")).then(() => parcelRequire('4jdx4'));